<template>
  <div>

    <b-tabs content-class="p-3 text-muted">
      <b-tab active @click.prevent="handleTabClick('')">
        <template v-slot:title>
          <span class="
        d-inline-block
        d-sm-none">
            <i class="fas fa-user-cog"></i>
          </span>
          <span class="d-none d-sm-inline-block">
            Αναλυτικό πρόγραμμα</span>
        </template>
        <div class="row">
          <div class="col-lg-12">

            <div class="card">
              <div class="card-body border-bottom">
                <div class="d-flex justify-content-between align-items-end gap-2" style="font-size: 0.9rem !important;">
                  <button class="btn btn-success" @click.prevent="$bvModal.show(`RelCreate`)"><i
                      class="mdi mdi-calendar-outline"></i>Καταχώριση προγράμματος</button>

                  <b-modal :id="`RelCreate`" :title="`Καταχώριση προγράμματος`" centered hide-footer>
                    <scheduleModalVue status="create" @CreateSchedule="createdScheduleModal"></scheduleModalVue>
                  </b-modal>
                </div>
                <hr />
                <div class="d-flex align-items-center">
                  <div class="flex-shrink-0"><select class="form-select" aria-label="Default select example"
                      v-model="currentMonth" @keyup.enter="submitFilterSearch">

                      <option v-for="(month, index) in months" :key="index + 1" :value="index + 1">
                        {{ month }}
                      </option>
                    </select></div>
                  <div class="flex-shrink-0 mx-4">
                    <b-col md="6">
                      <b-form-input v-model="currentYear" @keyup.enter="submitFilterSearch" type="text"
                        placeholder="YYYY" autocomplete="off" @blur="validateYear"
                        :class="{ 'is-invalid': yearError }"></b-form-input>
                      <div v-if="yearError" class="invalid-feedback">
                        Εισαγάγετε ένα έγκυρο τετραψήφιο έτος.
                      </div>
                    </b-col>
                  </div>

                  <div class="flex-shrink-0">

                    <button type="button" class="btn btn-primary" @click="submitFilterSearch"><i
                        class="mdi mdi-filter-outline"></i>Αναζήτηση</button>

                  </div>

                </div>

              </div>
              <div class="card-body">
                <div class="table-responsive">
                  <table class="table table-bordered align-middle nowrap">
                    <thead>
                      <tr>
                        <th scope="col">A/A</th>
                        <th scope="col">Από</th>
                        <th scope="col">Μέχρι</th>
                        <th scope="col">Ημέρες</th>
                        <th scope="col">Ώρα Έναρξης</th>
                        <th scope="col">Ώρα Λήξης</th>
                        <th scope="col">Νυχτερινό</th>
                        <th scope="col"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(object, index) in personWorkingScheduleData" :key="object.id"
                        :class="{ 'table-success': object.is_active }">

                        <th scope="row">{{ calculateIndex(index) }}</th>
                        <td>{{ formatDate(object.start_date) }}</td>
                        <td>{{ formatDate(object.end_date) }}</td>
                        <td>{{ formatWeekdays(object.weekdays) }}</td>
                        <td>{{ formatTime(object.start_time) }}</td>
                        <td>{{ formatTime(object.end_time) }} </td>
                        <td><span :class="getShiftClass(object.is_night_shift)"><i
                              :class="getShiftIcon(object.is_night_shift)"></i></span></td>

                        <td>
                          <ul class="list-unstyled hstack gap-1 mb-0">

                            <b-modal :id="`Rel${object.id}`" :title="`Επεξεργασία προγράμματος`" centered hide-footer>
                              <scheduleModalVue status="update" :object="object"
                                @UpdatedSchedule="UpdatedScheduleModal">
                              </scheduleModalVue>
                            </b-modal>

                            <li data-bs-toggle="tooltip" data-bs-placement="top" aria-label="Edit"><a
                                @click.prevent="$bvModal.show(`Rel${object.id}`)" class="btn btn-sm btn-info"><i
                                  class="mdi mdi-pencil-outline"></i></a></li>
                            <li v-if="object.can_change" data-bs-toggle="tooltip" data-bs-placement="top"
                              aria-label="Delete"><a @click.prevent="handleDelete(object)" data-bs-toggle="modal"
                                class="btn btn-sm btn-danger"><i class="mdi mdi-delete-outline"></i></a></li>
                          </ul>
                        </td>
                      </tr>

                    </tbody>
                  </table>
                </div>

                <b-pagination v-model="currentPage" :total-rows="totalCountSchedules"
                  :per-page="perPage"></b-pagination>

              </div>
            </div>
          </div>

        </div>

      </b-tab>
      <b-tab @click="handleTabClick('calendarSchedule')">
        <template v-slot:title>
          <span class="d-inline-block d-sm-none">
            <i class="fas fa-user-cog"></i>
          </span>
          <span class="d-none d-sm-inline-block">
            Ημερολόγιο</span>
        </template>

        <calendarSchedule :is="currentTabComponent"></calendarSchedule>
      </b-tab>
    </b-tabs>

  </div>
</template>


<script>
import { weekDays } from "../utils";
import moment from "moment";
import session from "../../../../api/session";
import Swal from "sweetalert2";
import scheduleModalVue from "./scheduleComponents/scheduleModalVue.vue";

import calendarSchedule from "./scheduleComponents/calendarSchedule.vue";

export default {
  name: "PersonWorkingSchedule",
  // components: { scheduleModalVue },
  components: { calendarSchedule, scheduleModalVue },
  props: [
    "personWorkingScheduleData",
    "currentSchedulePage",
    "totalCountSchedules",
  ],

  data() {
    return {
      weekdaySelected: [],
      startDate: "",
      endDate: "",
      currentMonth: "",
      currentYear: "",
      yearError: false,
      currentPage: 1,
      perPage: 10,
      months: [
        "Ιανουάριος",
        "Φεβρουάριος",
        "Μάρτιος",
        "Απρίλιος",
        "Μάιος",
        "Ιούνιος",
        "Ιούλιος",
        "Αύγουστος",
        "Σεπτέμβριος",
        "Οκτώβριος",
        "Νοέμβριος",
        "Δεκέμβριος",
      ],
      currentTabComponent: null,
      calendarPersonSchedule: [],
    };
  },
  mounted() {
    this.currentMonth = parseInt(moment().format("M"));
    this.currentYear = moment().format("Y");
  },

  watch: {
    currentYear(newYear) {
      this.yearError = !this.isValidYear(newYear);
    },
    currentPage(value) {
      this.submitNextPage(value);
    },
  },

  computed: {
    weekdayOptions() {
      return weekDays;
    },
  },

  methods: {
    handleTabClick(componentName) {
      if (!componentName) {
        this.submitFilterSearch();
      }
      this.currentTabComponent = componentName;
    },
    onClickSchedule(e) {
      console.log(e.schedule);
    },
    calculateIndex(index) {
      return index + 1 + (this.currentPage - 1) * this.perPage;
    },
    createdScheduleModal() {
      this.$bvModal.hide(`RelCreate`);

      this.submitFilterSearch();
    },
    UpdatedScheduleModal(objectId) {
      this.$bvModal.hide(`Rel${objectId}`);
      this.submitFilterSearch();
    },
    isValidYear(year) {
      const yearPattern = /^\d{4}$/;
      return yearPattern.test(year);
    },
    validateYear() {
      if (!this.isValidYear(this.currentYear)) {
        this.yearError = true;
      } else {
        this.yearError = false;
      }
    },
    getShiftClass(isNightShift) {
      return isNightShift
        ? "badge badge-soft-success"
        : "badge badge-soft-danger";
    },
    getShiftIcon(isNightShift) {
      return isNightShift ? "mdi mdi-check" : "mdi mdi-close";
    },
    formatDate(date) {
      return moment(date).format("DD-MM-YYYY");
    },
    formatWeekdays(weekdayList) {
      const weekdayNames = this.weekdayOptions
        .filter((e) => weekdayList.includes(e.id + 1))
        .map((w) => w.weekday);

      return weekdayNames.join(", ");
    },
    formatTime(time) {
      return moment(time, "HH:mm:ss").format("HH:mm");
    },
    submitNextPage(page) {
      if (this.yearError) {
        return;
      }
      this.$emit(
        "submitScheduleNextPage",
        this.currentMonth,
        this.currentYear,
        page
      );
    },

    submitFilterSearch() {
      if (this.yearError) {
        return;
      }
      this.$emit("searchFilters", this.currentMonth, this.currentYear);
    },
    handleDelete(row) {
      Swal.fire({
        title: "Είστε σίγουροι;",
        text: "Δεν θα μπορείτε να το επαναφέρετε!",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#34c38f",
        cancelButtonColor: "#f46a6a",
        confirmButtonText: "Ναι, διαγράψτε το!",
        cancelButtonText: "Άκυρο",
      }).then((result) => {
        if (result.value) {
          session
            .delete(`api/user/schedule/${row.id}/delete/`)
            .then(() => {
              Swal.fire({
                title: "Διαγράφηκε!",
                icon: "success",
                timer: 3000,
              });
              this.submitFilterSearch();
            })
            .catch((e) => {
              this.$toastr.e(Object.values(e.response.data));
            });
        }
      });
    },
  },
};
</script>
<style>
.font-size-14 {
  font-size: 10px;
}

.bx-calendar {
  margin-right: 5px;
}

.no-border {
  border: none;
  background-color: transparent;
  outline: none;
  padding: 0;
}

.schedule-container {
  display: flex;
  flex-direction: column;
}

.mdi-pencil {
  padding: 10px;
  color: rgb(224, 151, 15);
  transition: all 0.4s;
  margin-right: 5px;
  cursor: pointer;
  font-size: 15px;
}

.mdi-trash-can {
  color: red;
  padding: 10px;
  transition: all 0.6s;
  cursor: pointer;
  font-size: 15px;
}
</style>
<style scoped>
::v-deep .custom-checkbox .form-check-input {
  width: 30px;
  height: 30px;
}
</style>